import React from 'react'
import {
  AuthProvider,
  type ServerAuthProviderConfig,
} from '@rumah-pendidikan/auth/react'

import { SESSION } from 'src/constant'
import { auth } from 'src/lib/auth'

// Browsers block the SDK's default hidden-iframe probe across registrable
// domains, so probe with a top-level redirect instead. SDK 0.8.0 spelling;
// 0.9.0 renames it to 'top_level_redirect'.
const SEAMLESS_LOGIN_BOOTSTRAP_STRATEGY = 'top_level_prompt_none'

const baseConfig = auth.reactConfig as ServerAuthProviderConfig

const reactConfig: ServerAuthProviderConfig = {
  ...baseConfig,
  initialization: {
    ...baseConfig.initialization,
    serverBootstrapStrategy: SEAMLESS_LOGIN_BOOTSTRAP_STRATEGY,
    // Only bootstrap for users we already signed in. Guests go straight to
    // /login, which signs them in silently anyway.
    serverGuestLoginIdentifier: { cookieName: SESSION.USER_SESSION },
  },
}

export function IdpAuthProvider({ children }: { children: React.ReactNode }) {
  return <AuthProvider config={reactConfig}>{children}</AuthProvider>
}
